import { useGetHealthSummaryV2 } from '@viome/viome-base/src/usecase/Home/HomeQuery';
import { Skeleton } from '@design-system/Skeleton';
import { Button } from '@design-system/Button';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { HEALTH_PATH } from '@/constants/paths';
import { getBackgroundImageUrl } from '@utils/nutrition/getImageUrl';

export const HomeScoresSection = () => {
  const { data: healthSummaryData, isLoading, isError } = useGetHealthSummaryV2();

  const rankStyles: Record<string, string> = {
    Maintain: '#00CA9F',
    Improve: '#FFAB01',
    Attention: '#FF3A3A',
  };

  const rankOrder: Record<string, number> = {
    Maintain: 0,
    Improve: 1,
    Attention: 2,
  };

  if (isError) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="w-full p-6 rounded-xl bg-black/50 backdrop-blur-[50px]">
        <Skeleton className="h-32 w-full rounded" />
      </div>
    );
  }

  if (!healthSummaryData?.scores) {
    return null;
  }

  const sortedScoresData = healthSummaryData.scores.sort(
    (a, b) => rankOrder[a.rank] - rankOrder[b.rank],
  );

  return (
    <div
      className="w-full p-6 pr-0 pb-0 bg-card-foreground rounded-lg object-cover"
      style={{
        backgroundImage: `url(${getBackgroundImageUrl('health_score_background.png')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        objectFit: 'contain',
      }}
    >
      <div className="flex flex-col mb-4">
        <div className="flex justify-between">
          <p className="text-white typography-h3 max-w-96">
            We translated activities we detected into health scores you can
            track.
          </p>
          <Button className="bg-transparent w-16 !pr-16 !gap-0 items-center !-mt-3 hidden sm:flex">
            <Link to={HEALTH_PATH}>Health</Link>
            <ChevronRight />
          </Button>
        </div>

        <div className="flex items-center pt-8">
          <div className="flex gap-12 mb-6">
            {sortedScoresData.map((score, index) => (
              <div key={index}>
                <p className="typography-num-100" style={{ color: '#F4F4F5' }}>
                  {score.count}
                </p>
                <div className="flex flex-col">
                  <span className="dark text-primary whitespace-nowrap">
                    Scores {score.rank === 'Attention' ? 'need' : 'to'}
                  </span>
                  <span style={{ color: rankStyles[score.rank] }}>
                    {score.rank}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-6">
          <Button className="bg-transparent w-16 !gap-0 items-center !-mt-3 flex sm:hidden">
            <Link to={HEALTH_PATH}>Health</Link>
            <ChevronRight />
          </Button>
        </div>
      </div>
    </div>
  );
};
